import gql from 'graphql-tag';

import type { BrandTerm } from 'src/data/brandTerm';
import { executeGqlQuery } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_BRAND_TERM } from './schema';

const QUERY = gql`
  query BrandTerms($brandVoiceId: ID!) {
    brandTerms(brandVoiceId: $brandVoiceId) {
      ...BrandTerm
    }
  }
  ${FRAGMENT_BRAND_TERM}
`;

export const queryBrandTerms = async (brandVoiceId: ID): Promise<BrandTerm[] | undefined> => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: { brandVoiceId },
  });
  return getSingleProp<BrandTerm[]>(result.data);
};
